import { useState, useEffect } from 'react'
import {
    IconButton,
    Tooltip
} from '@mui/material'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import './toast.scss'

const Toast = ({ dispatch, toastType, id = '', title = '', message = '', autoHide = true }) => {
    const DURATION = 700
    const [close, setClose] = useState(false)
    const [hiding, sethiding] = useState(false)
    const [barWidth, setBarWidth] = useState(0)
    const [intervalID, setIntervalID] = useState(null)
    const toastClass = toastType?.toString()

    const closeToast = () => {
        clearInterval(intervalID)
        setTimeout(() => {
            dispatch({
                type: 'REMOVE_TOAST',
                id: id,
            })
        }, DURATION)
        new Promise(resolve => setTimeout(resolve, 200)).then(() => { 
            setClose(true)
         });
    }

    const hideToast = () => {
        sethiding(true)
        closeToast()
    }

    useEffect(() => {
        handleStartTimer()
    }, [])

    useEffect(() => {
        if (barWidth === 100 && autoHide) {
            hideToast()
        }
    }, [dispatch, setClose, id, intervalID, barWidth])

    const handleStartTimer = () => {
        const auxId = setInterval(() => {
            setBarWidth((prev) => {
                if (prev < 100) {
                    return prev + 0.5
                }
                clearInterval(auxId)
                return prev
            })
        }, 20)

        setIntervalID(auxId)
    }

    const handlePauseTimer = () => {
        clearInterval(intervalID)
    }

    return (
        <>
            {!close && (<div
                onMouseEnter={handlePauseTimer}
                onMouseLeave={handleStartTimer}
                className={`toast ${toastClass} ${hiding && 'close'}`}
            >
                <div className="text-wrapper">
                    <div className="close">
                        <Tooltip title="Cerrar Mensaje">
                            <IconButton onClick={hideToast}>
                                <CloseOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                    {title && <h4 className="bold">{title}</h4>}
                    <p>{message}</p>
                </div>
                <div className="bar" style={{ width: `${barWidth}%` }} />
            </div>
            )}
        </>
    )
}

export default Toast
